import React from 'react';
import { Input, Checkbox } from '../../../../common/components/formControls';
import { Field } from 'redux-form';
import validators from '../../../../common/services/validators';

const PonchoPayForm = ({ enabled, t }) => {
    return (
        <div>
            <Field name='integrationKey' component={Input} required type='text' label={t('PonchoPay_IntegrationKey')} validate={enabled && validators.required} trimOnBlur />
            <Field name='locationUrn' component={Input} required type='text' label={t('PonchoPay_LocationUrn')} validate={enabled && validators.required} trimOnBlur />
            <Field name='additionalFee' component={Input} type='text' label={t('PaymentMethod_AdditionalFee')} validate={[validators.number]} />
            <Field name='isAdditionalFeePercentage' component={Checkbox} label={t('PaymentMethod_IsAdditionalFeePercentage')} help={t('PaymentMethod_AdditionalFeeComplianceNote')} normalize={v => !!v} />
            <Field name='useSandbox' component={Checkbox} label={t('PonchoPay_UseSandbox')} help={t('PaymentMethod_UseSandbox_HelpText')} normalize={(v) => !!v} />
        </div>
    );
};


export default PonchoPayForm;